import { InferredProgressValue, Project } from 'api/project';

export const getIpDays = (
  project: Pick<Project, 'inferredProgress' | 'inferredProgressDays'>,
): number | undefined => {
  const { inferredProgress } = project;

  if (inferredProgress == null) {
    return undefined;
  }

  const days = project.inferredProgressDays ?? undefined;

  if (days === 0) {
    switch (inferredProgress.value) {
      case InferredProgressValue.AHeadOfTime:
        return 1;
      case InferredProgressValue.OnTrack:
        return 0;
      case InferredProgressValue.RunningLate:
        return -1;
      case InferredProgressValue.None:
      default:
        return undefined;
    }
  }

  return days;
};
